import { render, staticRenderFns } from "./ContentGallery.vue?vue&type=template&id=18c497f7&"
import script from "./ContentGallery.vue?vue&type=script&lang=js&"
export * from "./ContentGallery.vue?vue&type=script&lang=js&"
import style0 from "./ContentGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports